import { render, staticRenderFns } from "./DocTypeForm.vue?vue&type=template&id=764aabed&scoped=true"
import script from "./DocTypeForm.vue?vue&type=script&lang=js"
export * from "./DocTypeForm.vue?vue&type=script&lang=js"
import style0 from "./DocTypeForm.vue?vue&type=style&index=0&id=764aabed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764aabed",
  null
  
)

export default component.exports